/*
 * Copyright 2025 Intuition Robotics ltd
 */
import React from "react";
import {MessageStatuses} from "@app/ir-q-app-common/types/message";
import {ICONS} from "@res/icons";
import {COLORS} from "@res/colors";

type Props = {
	status: MessageStatuses
}

export class IconStatus
	extends React.Component<Props> {

	constructor(props: Props) {
		super(props);
	}

	render() {
			switch (this.props.status) {
				case MessageStatuses.SENT:
					return ICONS.icon_sentMessage("#b4b8bc", 24);
				case MessageStatuses.RECEIVED:
					return ICONS.icon_receivedMessage("#b4b8bc", 24);
				case MessageStatuses.READ:
					return ICONS.icon_readMessage(COLORS.sap_green, 24);
				case MessageStatuses.FAILED:
					return ICONS.icon_failedMessage(COLORS.red, 24);
				case MessageStatuses.RETRIED:
				default:
					return <div/>
			}
	}
}